import styled from 'foundations-theming-specialty/utils';
import { usePortal, useTranslation } from '../../hooks/useNavConfig';
import { MenuItem } from '../Menu';
import { getFullUrl } from 'hubspot-url-utils';
// @ts-expect-error bender imports are untyped
import defaultAvatar from 'bender-url!../../../img/default-avatar.png';
import { ButtonWithDemoExitConfirmation } from '../DemoExitConfirmation/ButtonWithDemoExitConfirmation';
import { getTypographyStylesV2 } from 'breadcrumbs-ui/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UserPrefTextContainer = styled.div.withConfig({
  displayName: "UserPreferences__UserPrefTextContainer",
  componentId: "mt8vla-0"
})(({
  theme
}) => ({
  paddingLeft: '60px !important',
  marginTop: `${theme.space['200']} !important`,
  marginBottom: `${theme.space['200']} !important`
}));
const UserAvatar = styled.img.withConfig({
  displayName: "UserPreferences__UserAvatar",
  componentId: "mt8vla-1"
})(({
  theme
}) => ({
  width: '48px',
  height: '48px',
  left: theme.space['400'],
  top: theme.space['400'],
  position: 'absolute',
  margin: `${theme.space['0']} !important`,
  borderRadius: '50%'
}));
const UserName = styled.div.withConfig({
  displayName: "UserPreferences__UserName",
  componentId: "mt8vla-2"
})(({
  theme
}) => Object.assign({
  color: `${theme.color['text-core-default']} !important`,
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
  textDecoration: 'none !important'
}, getTypographyStylesV2(theme, 'heading-100'), {
  ':hover': {
    textDecoration: 'none !important'
  }
}));
const UserEmail = styled.div.withConfig({
  displayName: "UserPreferences__UserEmail",
  componentId: "mt8vla-3"
})(({
  theme
}) => Object.assign({
  color: `${theme.color['text-core-default']} !important`,
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
  textDecoration: 'none !important'
}, getTypographyStylesV2(theme, 'body-100'), {
  ':hover': {
    textDecoration: 'none !important'
  }
}));
const UserLink = styled.div.withConfig({
  displayName: "UserPreferences__UserLink",
  componentId: "mt8vla-4"
})(({
  theme
}) => Object.assign({
  color: `${theme.color['text-interactive-default']} !important`
}, getTypographyStylesV2(theme, 'body-125'), {
  textDecoration: 'none !important',
  cursor: 'pointer !important',
  display: 'inline-block !important',
  ':hover': {
    textDecoration: 'underline !important'
  }
}));
const StyledMenuItem = styled(MenuItem)(({
  theme
}) => ({
  listStyleType: 'none !important',
  display: 'block',
  position: 'relative',
  color: `${theme.color['text-core-default']} !important`,
  borderBottom: `${theme.borderWidth['100']} solid ${theme.color['border-core-default']} !important`,
  minHeight: '80px',
  padding: `${theme.space['200']} ${theme.space['400']} !important`,
  ':hover': {
    [UserLink.toString()]: {
      textDecoration: 'underline !important'
    }
  }
}));
const UserPreferences = ({
  avatarUrl,
  userName,
  userEmail
}) => {
  const {
    t
  } = useTranslation();
  const {
    portalId
  } = usePortal();
  const imgSrc = encodeURI(avatarUrl);
  const preferencesText = t('nav.tools.profileAndPreferences');
  const href = `${getFullUrl('app')}/user-preferences/${portalId || ''}`;
  return /*#__PURE__*/_jsxs(ButtonWithDemoExitConfirmation, {
    component: StyledMenuItem,
    id: "userPreferences",
    href: href,
    "data-test-id": "nav-account-menu-user-preferences",
    style: {
      textDecoration: 'none'
    },
    children: [/*#__PURE__*/_jsx(UserAvatar, {
      alt: userName,
      src: imgSrc || defaultAvatar,
      "aria-hidden": "true"
    }), /*#__PURE__*/_jsxs(UserPrefTextContainer, {
      children: [/*#__PURE__*/_jsx(UserName, {
        children: userName
      }), /*#__PURE__*/_jsx(UserEmail, {
        children: userEmail
      }), /*#__PURE__*/_jsx(UserLink, {
        children: preferencesText
      })]
    })]
  });
};
export default UserPreferences;